import * as Yup from "yup";
import { validatorStringTextOnly } from "../validatorStringTextOnly";
import { getValidatorAddressStreet } from "./validatorAddressStreet";
import { getValidatorPostalCode } from "./validatorPostalCode";
import { validatorRegion } from "./validatorRegion";

export const getValidationSchemaAddress = (
  country: string,
  options?: {
    allowPOBox?: boolean;
  }
) => {
  const validatorAddressStreet = getValidatorAddressStreet(options?.allowPOBox);

  return Yup.object().shape({
    addressLine1: validatorAddressStreet.required("Required"),
    addressLine2: validatorAddressStreet.when("addressLine1", {
      is: (addressLine1: string) => addressLine1 !== "",
      then: () =>
        validatorAddressStreet.notOneOf(
          [Yup.ref("addressLine1")],
          "It appears that you've already wrote this part of address in first line"
        ),
      otherwise: () => validatorAddressStreet.notRequired()
    }),
    city: validatorStringTextOnly.required("Required"),
    state: validatorRegion(country),
    postalCode: getValidatorPostalCode(country)
  });
};
